import store from './store'
import router from './router'
import Blob from './excel/Blob.js'
import Export2Excel from './excel/Export2Excel.js'
import './components/common/directives';
import './tools/dialog.js'
import App from './App' 
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
 
new Vue({
  el: '#app',
  router,
	store,
  render: h => h(App)
})

String.prototype.PadLeft = function (len, charStr) {
        var s = this + '';
        return new Array(len - s.length + 1).join(charStr,  '') + s;
    }
Date.prototype.Format = function (fmt) {
				    var o = {
				        "M+": this.getMonth() + 1, //月份
				        "d+": this.getDate(), //日
				        "H+": this.getHours(), //小时
				        "m+": this.getMinutes(), //分
				        "s+": this.getSeconds(), //秒
				        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
				        "S": this.getMilliseconds() //毫秒
				    };
				    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
				    for (var k in o)
				    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
				    return fmt;
				}
// VXETablePluginExportPDF.setup({
//   // Set default font
//   fontName: 'SourceHanSans-Normal',
//   // Font maps
//   fonts: [
//     {
//       // Font name
//       fontName: 'SourceHanSans-Normal',
//       // Font library url
//       fontUrl: 'https://cdn.jsdelivr.net/npm/vxe-table-plugin-export-pdf/fonts/source-han-sans-normal.js'
//     }
//   ]
// })



// WEBPACK FOOTER //
// ./src/main.js